"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.VerificationStatusToJSON = exports.VerificationStatusFromJSONTyped = exports.VerificationStatusFromJSON = exports.VerificationStatus = void 0;
/**
 * Indicates the status of the verification process for the current customer
 * @export
 * @enum {string}
 */
var VerificationStatus;
(function (VerificationStatus) {
    VerificationStatus["Verified"] = "verified";
    VerificationStatus["WaitingForClick"] = "waitingForClick";
    VerificationStatus["NotVerified"] = "notVerified";
})(VerificationStatus = exports.VerificationStatus || (exports.VerificationStatus = {}));
function VerificationStatusFromJSON(json) {
    return VerificationStatusFromJSONTyped(json, false);
}
exports.VerificationStatusFromJSON = VerificationStatusFromJSON;
function VerificationStatusFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.VerificationStatusFromJSONTyped = VerificationStatusFromJSONTyped;
function VerificationStatusToJSON(value) {
    return value;
}
exports.VerificationStatusToJSON = VerificationStatusToJSON;
//# sourceMappingURL=VerificationStatus.js.map